import UrlTileClass, * as UrlTileModule from './../../node_modules/ol/source/UrlTile.js';

class UrlTile extends UrlTileClass {
    constructor(options = {}) {
        options = options || {}
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in UrlTileModule) {
    if (key !== "default") {
        UrlTile[key] = UrlTileModule[key];
    }
}

export default UrlTile;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol/source/UrlTile.js';